'use client';

import {
  Select,
  SelectContent,
  SelectTrigger,
  SelectValue
} from '@/components/shadcn/Select';

type Year = {
  date: '年';
  placeholder: '例 :  1998年';
};

type Month = {
  date: '月';
  placeholder: '例 :  1月';
};

type Day = {
  date: '日';
  placeholder: '例 :  1日';
};

type Props = {
  value: string;
  onChange: (arg: string) => void;
  optionElements: JSX.Element[];
  className: string;
} & (Year | Month | Day);

export default function Birthday({
  value,
  onChange,
  optionElements,
  date,
  placeholder,
  className
}: Props) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className={className}>
        <SelectValue placeholder={placeholder}>
          {value ? value + date : ''}
        </SelectValue>
      </SelectTrigger>
      <SelectContent data-scrollable>{optionElements}</SelectContent>
    </Select>
  );
}
